import type { BenchmarkGranularity } from "app/pages/benchmark-tracker/services/api/constants";

import { BENCHMARK_DOWNLOAD_EXCEL_DROPDOWN_URL } from "./constants";

type getExcelDownloadUrlSchema = {
    country: string;
    formattedDuration: string;
    granularity: BenchmarkGranularity;
    benchmarkId: string;
};

export const getExcelDownloadUrl = ({
    country,
    formattedDuration,
    granularity,
    benchmarkId,
}: getExcelDownloadUrlSchema) => {
    return `${BENCHMARK_DOWNLOAD_EXCEL_DROPDOWN_URL}?country=${country}&startDate=${formattedDuration}&granularity=${granularity}&id=${benchmarkId}`;
};
